import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useOrderTypes = defineStore('order-types', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.orderType_GetOrderTypes,
    dto: 'OrderTypeSimple',
    create: api.orderType_AddOrderType,
    update: api.orderType_UpdateOrderType,
    delete: api.orderType_DeleteOrderType,
    usage: api.orderType_GetOrderTypeUsage,
    signalR: 'OrderTypeUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
